/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { useHistory } from 'react-router-dom' // Npm: react-router-dom for routing.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiAdjustmentsHorizontal, HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  mccId,
  mccIds,
  onMccUpdate,
  onMccDelete,
  PassOnUpdate,
  selectedIds
}) => {
  // Hook assignment.
  const _historyRef = useHistory()
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  // Event handler 
  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  // Event handler 
  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return Component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            // Push mcc id to Redux state.
            PassOnUpdate({ mccIds, mccId })

            // Execute update handler.
            onMccUpdate(selectedIds)

            // Close menu.
            _handleClose()
          }}
        >
          <HiPencil size={18} />
          <span>Edit Mcc</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push mcc id to Redux state.
            PassOnUpdate({ mccIds, mccId })

            // Execute delete handler.
            onMccDelete(selectedIds)

            // Close menu.
            _handleClose()
          }}
        >
          <HiTrash size={18} />
          <span>Delete Mcc</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push mcc id to Redux state.
            PassOnUpdate({ mccId })

            // Navigate to Mnc management page.
            _historyRef.push('/network/mcc/mnc')

            // Close menu.
            _handleClose()
          }}
        >
          <HiAdjustmentsHorizontal size={18} />
          <span>Manage Mnc</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'mccId': PropTypes.string,
  'mccIds': PropTypes.array,
  'onMccUpdate': PropTypes.func,
  'onMccDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'selectedIds': PropTypes.array
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
